module.exports = __webpack_public_path__ + "static/media/Project-Information.50241ea3.svg";